import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Statics from "./components/Statics";
import style from "./index.module.scss";
import { CourseContext } from "pages/CourseDetail/Store";

interface ButtonsProps {
    status: string;
    allCount: string;
    joinCount: string;
    noJoinCount: string;
    onChange: (val: string) => void;
    questionnaireId: number;
}

export default function Buttons({
    status,
    allCount,
    joinCount,
    noJoinCount,
    onChange,
    questionnaireId
}: ButtonsProps) {
    const history = useHistory();
    const { basename } = useContext(CourseContext);

    return (
        <div className={style.root}>
            <Statics
                current={status}
                onChange={onChange}
                allCount={allCount}
                noJoinCount={noJoinCount}
                joinCount={joinCount}
            />
            <div className={style.buttons}>
                <button
                    className={style.btnView}
                    onClick={() =>
                        history.replace(
                            `${basename}/question/static/${questionnaireId}`
                        )
                    }>
                    查看问卷分析
                </button>
            </div>
        </div>
    );
}
